import UpdateCurrencyRate from './UpdateCurrencyRate';

export default UpdateCurrencyRate;
